module.exports = __webpack_public_path__ + "img/16.dcc29f08.png";